import { ArriveDepartIso } from '../../search/types'

export function validateAvailabilityCheck({
  dates,
}: {
  dates: ArriveDepartIso | null
}) {
  if (dates && dates.arrive && dates.depart) {
    return false
  } else {
    return 'You must provide dates'
  }
}
